<template>
  <div id="app">
    <!-- 主应用的menu，所有子应用都要使用 -->
    <!-- <el-header style="padding: 0; margin-bottom: 26px">
      <OEMHeader></OEMHeader>
    </el-header> -->

    <!-- 承接主应用的page -->
    <router-view />

    <!-- 承接子应用的容器 -->
    <!-- <div id="container"></div> -->
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
html,
body {
  height: 100%;  
  touch-action: none;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}

/*全局覆盖图标 */
.el-icon-error {
  background: url("data:image/png;base64,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")
    center center no-repeat;
  background-size: 24px;
  background-size: 14px 14px;
  width: 14px;
  height: 14px;
}
.el-message--error .el-message__content {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65) !important;
}

/*滚动条整体样式*/
::-webkit-scrollbar {
    /*高宽分别对应横竖滚动条的尺寸*/
    /* Y轴/竖的滚动条的宽度 */
    width: 6px;
    /* X轴/横滚动条的高度 */
    height: 6px;
}

::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 6px;
    background: #b8b7b7;
}

::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 6px;
    background: transparent;
}
.el-table__expand-icon{
  transform:rotate(360deg) !important
}
.el-table__expand-icon--expanded{
  transform:rotate(270deg) !important
}
</style>
